module.exports = __webpack_public_path__ + "static/img/m-H1B.73da171d.png";